import { render, staticRenderFns } from "./ReviewableExtractionField.vue?vue&type=template&id=2ffa182b&scoped=true&"
import script from "./ReviewableExtractionField.vue?vue&type=script&lang=js&"
export * from "./ReviewableExtractionField.vue?vue&type=script&lang=js&"
import style0 from "./ReviewableExtractionField.vue?vue&type=style&index=0&id=2ffa182b&lang=scss&scoped=true&"
import style1 from "./ReviewableExtractionField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa182b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VExpansionPanel,VExpansionPanelContent,VItem,VItemGroup,VRow})
